
import * as types from '../constants/ActionTypes'
//import _ from 'lodash'

export default function notifications(state = {
  sessions: {}
}, action) {
	switch (action.type) {

    case types.UPDATE_SESSION_NOTIFICATION:
    return {...state, sessions: {...state.sessions, [action.payload.sessionId]: action.payload.data}}

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/notifications.js